import { laborApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'LABOR',
    api: laborApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'LABOR',
  api: laborApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'LABOR',
    api: laborApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'LABOR',
    api: laborApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'LABOR',
  api: laborApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'LABOR',
    api: laborApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('LABOR');
export const setDeletedPending = createListDataDeletedPending('LABOR');
